.root {
  display: inline-block;
  text-align: center;
}

.value {
  line-height: 1;
}

.current {
  color: var(--bc-color-primary);
  font-size: 32px;
  font-weight: 700;
}

.total {
  color: var(--bc-color-text-secondary);
  font-size: 16px;
  font-weight: 700;
}

.label {
  color: var(--bc-color-text);
  font-size: 12px;
  font-weight: 500;
  letter-spacing: 1px;
  text-transform: uppercase;
}
